import Vue from 'vue';
import { ModalService } from '@app/plugins/iview-modal-modify/service';
import { SenderService } from '@mailer/services/SenderService';
import AddSenderForm from '@mailer/components/senders/senders-form-create';
import i18n from '@app/plugins/i18n';

class SenderModalService extends ModalService {
  constructor() {
    super(SenderService);
  }

  remove(id, item) {
    return this.$removeItem(id, item, {
      content: i18n.t('mailer.sender.modal.remove.content', {
        name: `<strong>${item.name}</strong>`
      })
    });
  }

  deactivate(id, item) {
    return this.$confirm({
      loading: true,
      title: i18n.t('shared.component.modal.confirm'),
      content: i18n.t('mailer.sender.modal.deactivate.content', {
        name: `<strong>${item.name}</strong>`
      }),

      onOk: () => {
        SenderService.deactivate(id)
          .then(() => {
            this.$emit('success');
            this.modal.remove();
          })
          .catch((e) => {
            this.$emit('fail');
            this.modal.setLoading(false);
            Vue.noty.server_error(e);
          });
      }
    });
  }

  create() {
    return this.$open({
      title: i18n.t('mailer.sender.modal.add.title'),
      width: this.size.confirm,
      render: (h) => {
        return h(AddSenderForm, {
          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            },
            fail: (e) => {
              if(Array.isArray(e)) {
                Vue.noty.error(e[0]);
              }
              this.$emit('fail', e);
            }
          }
        });
      }
    });
  }
}

const instance = new SenderModalService();
export { instance as SenderModalService };
